<template>
  <div class="vue-wrapper-full">
    <TheLoader :active="!kunde"/>

    <keep-alive>
      <KundeCardSidebar v-if="kunde" :kunde="kunde" v-on:switchKundeView="onSwitchKundeView"/>
    </keep-alive>

    <transition name="component-fade" mode="out-in">
      <!--keep-alive :key="$route.fullPath"-->
      <component v-if="kunde" v-bind:is="selectedContentComponent"
                 v-bind="{kunde: kunde, kontrakt: kontrakt, objekt: objekt, objektList: objekter}"
                 v-on:switchKundeView="onSwitchKundeView"
                 v-on:switchEOFakturaView="onSwitchEOFakturaView"
                 v-on:switchKundeFakturerMultiple="onSwitchKundeFakturerMultiple"></component>
      <!--/keep-alive-->
    </transition>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import KundeCardSidebar from './KundeCardSidebar'
import KundeCardShow from './KundeCardShow'
import KundeCardEdit from './KundeCardEdit'
import EoFaktura from './EoFaktura'
import KundeFakturerMultiple from './KundeFakturerMultiple'
import KundeKontrakt from './KundeKontrakt'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCard',
  components: {
    KundeCardSidebar
  },
  data () {
    return {
      kunde: null,
      kontrakt: null,
      objekter: [],
      objekt: null,
      selectedContentComponent: KundeCardShow,
      loading: true
    }
  },
  mounted () {
    bus.$on('kunde-merged', (data) => this.onKundeMerged(data))
    bus.$on('kunde-updated', (item) => this.onKundeUpdated(item))
    bus.$on('kunde-kontrakt-deleted', (item) => this.onKundeKontraktDeleted(item))
    bus.$on('kunde-kontrakt-updated', (item) => this.onKundeKontraktUpdated(item))
    bus.$on('kunde-kontrakt-created', (item) => this.onKundeKontraktCreated(item))
    bus.$on('kunde-kontrakt-objekt-created', (item) => this.onKundeKontraktObjektCreated(item))
    bus.$on('kunde-kontrakt-objekt-updated', (item) => this.onKundeKontraktObjektUpdated(item))
    bus.$on('kunde-kontrakt-objekt-deleted', () => this.onKundeKontraktObjektDeleted())

    bus.$on('show-kunde-kontrakt', (item) => this.onShowKundeKontrakt(item))
    bus.$on('hide-kunde-kontrakt', () => this.onHideKundeKontrakt())

    bus.$on('show-kunde-kontrakt-objekt', (kontraktItem, objektItem, hash) => this.onShowKundeKontraktObjekt(kontraktItem, objektItem, hash))
    bus.$on('hide-kunde-kontrakt-objekt', () => this.onHideKundeKontraktObjekt())
    bus.$on('reload-kunde-kontrakt-objekt-modal', (kontraktItem, objektItem) => this.onReloadKundeKontraktObjektModal(kontraktItem, objektItem))

    bus.$on('switchKundeFakturerMultiple', (objekts) => this.onSwitchKundeFakturerMultiple(objekts))
    bus.$on('switchKundeFakturerMultipleOff', (objekts) => this.onSwitchKundeView(objekts))
  },
  created: function () {
    // Turn off listeners
    bus.$off('kunde-merged')
    bus.$off('kunde-kontrakt-updated')
    bus.$off('kunde-kontrakt-created')
    bus.$off('kunde-kontrakt-deleted')
    bus.$off('kunde-kontrakt-objekt-created')
    bus.$off('kunde-kontrakt-objekt-updated')

    bus.$off('show-kunde-kontrakt')
    bus.$off('hide-kunde-kontrakt')
    bus.$off('show-kunde-kontrakt-objekt')
    bus.$off('hide-kunde-kontrakt-objekt')
    bus.$off('reload-kunde-kontrakt-objekt-modal')

    this.$store.dispatch('kundekontrakt/setNeedReload')
    this.$store.dispatch('kundeobjektbuyer/setNeedReload')
    this.$store.dispatch('kundeobjektseller/setNeedReload')
    this.$store.dispatch('kundeobjektdeliver/setNeedReload')
    this.$store.dispatch('kundeobjektsignature/setNeedReload')

    this.fetch()
  },
  watch: {
    kontrakt: function () {
      this.$store.dispatch('kundekontraktobjekt/setNeedReload')
      this.$store.dispatch('kontraktnotat/setNeedReload')
      this.$store.dispatch('kontrakthistory/setNeedReload')
    }
  },
  methods: {
    fetch: function () {
      this.loading = true

      let regex = /^\d+$/
      let kundeNr = this.$route.params.kunde_id
      let kontraktNr = this.$route.query.kontrakt
      let objektNr = this.$route.query.objekt

      KundeService.view(kundeNr)
        .then((response) => {
          // Kunde loaded
          let kundeData = response.data

          // Now check what view to display
          if (kontraktNr && objektNr) {
            // Load objekt
            if (!regex.test(kontraktNr) || !regex.test(objektNr)) {
              this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
              this.showKunde(kundeData)
            } else {
              KundeService.getKundeKontraktObjekt(kundeNr, kontraktNr, objektNr)
                .then((response) => {
                  this.kunde = kundeData
                  this.kontrakt = response.data.kontrakt
                  this.onShowKundeKontraktObjekt(response.data.kontrakt, response.data)
                })
                .catch(() => {
                  this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
                  this.showKunde(kundeData)
                })
            }
          } else if (kontraktNr) {
            // Load kontrakt
            if (!regex.test(kontraktNr)) {
              this.$helpers.showErrorAlert('Feil', 'Kontrakt ikke funnet')
              this.showKunde(kundeData)
            } else {
              KundeService.getKundeKontrakt(kundeNr, kontraktNr)
                .then((response) => {
                  this.kunde = kundeData
                  this.onShowKundeKontrakt(response.data)
                })
                .catch(() => {
                  this.$helpers.showErrorAlert('Feil', 'Kontrakt ikke funnet')
                  this.showKunde(kundeData)
                })
            }
          } else {
            // Show Kunde
            this.showKunde(kundeData)
          }
        })
        .catch(() => {
          if (this.$store.getters.isLoggedIn) {
            this.$helpers.showErrorAlert('Feil', 'Kunde ikke funnet')

            this.$router.push({
              'name': 'KundeList'
            })
          }
        })
    },
    showKunde: function (kundeData) {
      this.kunde = kundeData

      document.title = 'Avanti - Kunde - ' + this.kunde.Kundenr

      if (this.$route.hash === '#edit') {
        this.selectedContentComponent = KundeCardEdit
      } else if (this.$route.hash === '#faktura') {
        this.selectedContentComponent = EoFaktura
      } else {
        this.selectedContentComponent = KundeCardShow
      }
    },
    onKundeUpdated: function (item) {
      this.kunde = item

      this.$store.dispatch('kundehistory/reload', {
        Kundenr: this.kunde.Kundenr
      })

      this.updateObjektModalProps({kunde: this.kunde})
    },
    onKundeMerged: function (data) {
      this.kunde = Object.assign({}, this.kunde, data)

      this.$store.dispatch('kundehistory/reload', {
        Kundenr: this.kunde.Kundenr
      })

      this.updateObjektModalProps({kunde: this.kunde})
    },
    onKundeKontraktCreated: function (item) {
      // After kontrakt created - reload kontrakt list.
      this.$store.dispatch('kundekontrakt/reload', {
        kundenr: this.kunde.Kundenr
      })

      // ...and display the new kontrakt
      this.onShowKundeKontrakt(item)
    },
    onKundeKontraktUpdated: function (item) {
      // After kontrakt updated - reload kontrakt list.
      this.$store.dispatch('kundekontrakt/reload', {
        kundenr: this.kunde.Kundenr
      })

      this.$store.dispatch('kontraktnotat/reload', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: item.Kontraktnr
      })

      this.$store.dispatch('kontrakthistory/reload', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: item.Kontraktnr
      })

      this.kontrakt = item
    },
    onKundeKontraktDeleted: function (item) {
      // After kontrakt updated - reload kontrakt list.
      this.$store.dispatch('kundekontrakt/reload', {
        kundenr: this.kunde.Kundenr
      })

      this.onHideKundeKontrakt()
    },
    onKundeKontraktObjektCreated: function (item) {
      // After objekt created - reload objekt list.
      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt
      })

      // Also reload kontrakt list
      this.$store.dispatch('kundekontrakt/reload', {
        kundenr: this.kunde.Kundenr
      })
    },
    onKundeKontraktObjektUpdated: function (item) {
      // After objekt created - reload objekt list.
      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt
      })

      this.objekt = item

      this.updateObjektModalProps({objekt: item})
    },
    onKundeKontraktObjektDeleted: function () {
      // Remove one objekt from total sold
      let total = parseInt(this.kunde.total_objekt_seller) - 1
      if (total < 0) {
        total = 0
      }

      // Weird but have to do it like this to not get warnings...
      let copy = this._.cloneDeep(this.kunde)
      copy.total_objekt_seller = total
      this.kunde = copy

      // Tells objekt list in kontraktview to update
      bus.$emit('kontrakt-objekter-deleted')

      // Now go to kontrakt
      this.onHideKundeKontraktObjekt()
    },
    onSwitchKundeView: function (editMode) {
      if (editMode) {
        this.$router.push({
          name: 'KundeCard',
          params: this.$route.params,
          query: {},
          hash: '#edit'
        })

        this.selectedContentComponent = KundeCardEdit
      } else {
        this.$router.push({
          name: 'KundeCard',
          params: this.$route.params,
          query: {},
          hash: ''
        })

        this.selectedContentComponent = KundeCardShow
      }
    },
    onSwitchEOFakturaView: function () {
      console.log('trying to switch EO Faktura')
      this.$router.push({
        name: 'KundeCard',
        params: this.$route.params,
        query: {},
        hash: '#eo-faktura'
      })

      this.selectedContentComponent = EoFaktura
    },
    onSwitchKundeFakturerMultiple: function (objekter) {
      console.log('Switching to Kunde fakturer')
      this.$router.push({
        name: 'KundeCard',
        params: this.$route.params,
        query: {},
        hash: '#fakturer'
      })
      this.objekter = objekter

      this.selectedContentComponent = KundeFakturerMultiple
    },
    onShowKundeKontrakt: function (item, skipHash) {
      // When switching to a different kontrakt, we need to reload some things...
      this.kontrakt = item
      this.objekt = null
      this.selectedContentComponent = KundeKontrakt

      document.title = 'Avanti - Kontrakt - ' + this.kontrakt.Kontraktnr

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {kontrakt: item.Kontraktnr},
        hash: !skipHash ? this.$route.hash : ''
      })
    },
    onHideKundeKontrakt: function () {
      this.kontrakt = null
      this.objekt = null
      this.selectedContentComponent = KundeCardShow

      document.title = 'Avanti - Kunde - ' + this.kunde.Kundenr

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: '',
        hash: ''
      })
    },
    onShowKundeKontraktObjekt: function (kontraktItem, objektItem, hash) {
      this.kontrakt = kontraktItem
      this.objekt = objektItem

      document.title = 'Avanti - Objekt - ' + this.objekt.Objektnr

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {...this.$route.query, kontrakt: kontraktItem.Kontraktnr, objekt: objektItem.Objektid},
        hash: hash || this.$route.hash
      })

      this.openModal(
        'kunde-kontrakt-objekt',
        {
          kunde: this.kunde,
          kontrakt: this.kontrakt,
          objekt: this.objekt
        },
        'fullscreen',
        'hide-kunde-kontrakt-objekt'
      )
    },

    onReloadKundeKontraktObjektModal: function (kontraktItem, objektItem) {
      this.kontrakt = kontraktItem
      this.objekt = objektItem

      document.title = 'Avanti - Objekt - ' + this.objekt.Objektnr

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {kontrakt: kontraktItem.Kontraktnr, objekt: objektItem.Objektid},
        hash: ''
      })

      this.closeModal()
      this.openModal(
        'kunde-kontrakt-objekt',
        {
          kunde: this.kunde,
          kontrakt: this.kontrakt,
          objekt: this.objekt
        },
        'fullscreen',
        'hide-kunde-kontrakt-objekt'
      )
    },

    onHideKundeKontraktObjekt: function () {
      this.objekt = null

      this.closeModal()
      if (this.$route.query.searchResult) {
        this.$router.push({ query: { ...this.$route.query, search: true } })
        bus.$emit('hide-kunde-kontrakt-objekt-done')
      } else {
        if (this.kontrakt) {
          this.onShowKundeKontrakt(this.kontrakt, true)
        } else {
          this.onHideKundeKontrakt()
        }
      }
    }
  }
}
</script>

<style scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeCard.vue